import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const LoginPage = lazy(() => import('./pages/LoginPage'));
// const SignupPage = lazy(() => import('./pages/SignupPage'));

export const ROUTES = [
    {
        path: '/login',
        element: (
            <Suspense fallback={<Spinner block />}>
                <LoginPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/signup',
        element: (
            <Suspense fallback={<Spinner block />}>
                <SignupPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/forgot-password',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ForgotPasswordPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    },
    {
        path: '/reset-password/:token',
        element: (
            <Suspense fallback={<Spinner block />}>
                <ResetPasswordPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
